import React from 'react';
import { Helmet } from 'react-helmet-async';

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Magicomms",
    "alternateName": "Magicomms Agency",
    "url": "https://magicomms.com",
    "logo": "https://magicomms.com/logo.png",
    "description": "Agenzia di comunicazione strategica specializzata in PR, media relations, ufficio stampa, comunicazione sportiva e corporate a Roma e in Italia.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Roma",
      "addressCountry": "IT"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": ["Italian", "English"]
    },
    "sameAs": [
      "https://www.instagram.com/magicomms"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Magicomms",
    "image": "https://magicomms.com/logo.png",
    "description": "Agenzia di comunicazione e PR a Roma specializzata in media relations, ufficio stampa, comunicazione sportiva, crisis management e digital content.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Roma",
      "addressRegion": "Lazio",
      "addressCountry": "IT"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.9028",
      "longitude": "12.4964"
    },
    "url": "https://magicomms.com",
    "telephone": "+39-XXX-XXXXXXX",
    "priceRange": "$$",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Italy"
    },
    "serviceType": [
      "PR & Strategy",
      "Media Relations",
      "Crisis Communication Management",
      "Digital Content & Brand Identity",
      "Partnership Management",
      "Networking & Business Relations",
      "Event Organization",
      "M&A Communication Consulting"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const ServiceSchema = ({ serviceName, description }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceName,
    "provider": {
      "@type": "Organization",
      "name": "Magicomms",
      "url": "https://magicomms.com"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Italy"
    },
    "description": description
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const ArticleSchema = ({ title, description, image, datePublished, dateModified, author }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "image": image,
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "author": {
      "@type": "Organization",
      "name": author || "Magicomms"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Magicomms",
      "logo": {
        "@type": "ImageObject",
        "url": "https://magicomms.com/logo.png"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://magicomms.com${item.path}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const WebPageSchema = ({ name, description, url }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": name,
    "description": description,
    "url": url,
    "inLanguage": "it-IT",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Magicomms",
      "url": "https://magicomms.com"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
